import { Link } from "@/lib/nav";
import { cn } from "@/lib/utils";
import { TOOLS_CONTAINER } from "@/pages/tools/_ui/tools-container";

import { Button } from "@buildpy/ui/button";

// 모든 무료 도구 바닥의 같은 안내 — 인쇄에서는 빠진다.
const ToolsCta = () => (
  <footer className="print-hide border-t border-border bg-muted">
    <div className={cn(TOOLS_CONTAINER, "flex flex-col items-start gap-3 py-6 md:flex-row md:items-center md:justify-between")}>
      <div className="text-sm">
        <p className="font-semibold">견적·계약·현장일지를 한 곳에서</p>
        <p className="text-muted-foreground">
          오늘의집은 그대로 쓰세요. 공사 기록과 시공사례는 사장님 것으로 쌓입니다.
        </p>
      </div>
      <Button asChild>
        <Link href="/">buildpy에서 바로 만들기</Link>
      </Button>
    </div>
  </footer>
);

export default ToolsCta;
